export const SkillsData = {
    languages: [
        {
            name: 'Python',
            image: 'https://res.cloudinary.com/dyg53cwvw/image/upload/c_scale,w_137/v1671543840/website%20images/Python_logo_01.svg_sq70cq.png',
            knowledge: 85
        },
        {
            name: 'JavaScript',
            image: 'https://res.cloudinary.com/dyg53cwvw/image/upload/c_scale,w_137/v1671543840/website%20images/javascript-logo-transparent-logo-javascript-images-3_ngbsk3.png',
            knowledge: 70
        },
        {
            name: 'Java',
            image: 'https://res.cloudinary.com/dyg53cwvw/image/upload/c_scale,w_137/v1672924713/website%20images/1200px-Java_Logo.svg_blctsn.webp',
            knowledge: 55
        },
        {
            name: 'HTML',
            image: 'https://res.cloudinary.com/dyg53cwvw/image/upload/c_scale,w_137/v1671543839/website%20images/HTML5_logo_and_wordmark.svg_accm22.png',
            knowledge: 95
        },
        {
            name: 'CSS',
            image: 'https://res.cloudinary.com/dyg53cwvw/image/upload/c_scale,w_137/v1671543839/website%20images/CSS3_logo_and_wordmark.svg_ejmfja.png',
            knowledge: 85
        }
    ],
    frameworks: [
        {
            name: 'Django',
            image: 'https://res.cloudinary.com/dyg53cwvw/image/upload/c_scale,w_137/v1671543840/website%20images/django_sxfu8z.svg',
            knowledge: 85
        },
        {
            name: 'Flask',
            image: 'https://res.cloudinary.com/dyg53cwvw/image/upload/c_scale,w_137/v1671553299/website%20images/pocoo_flask-ar21_h0aodw.png',
            knowledge: 70
        },
        {
            name: 'React',
            image: 'https://res.cloudinary.com/dyg53cwvw/image/upload/c_scale,w_137/v1672924713/website%20images/React-icon.svg_hkqoej.webp',
            knowledge: 75
        },
        {
            name: 'Bootstrap',
            image: 'https://res.cloudinary.com/dyg53cwvw/image/upload/c_scale,w_137/v1671543839/website%20images/Bootstrap_logo.svg_zsocty.png',
            knowledge: 80
        },
        {
            name: 'Materilaize',
            image: 'https://res.cloudinary.com/dyg53cwvw/image/upload/c_scale,w_137/v1671548952/website%20images/materialize-logo-0FCAD8A6F8-seeklogo.com_b0pjoa.png',
            knowledge: 75
        }
    ],
    integrations: [
        {
            name: 'MongoDB',
            image: 'https://res.cloudinary.com/dyg53cwvw/image/upload/c_scale,w_137/v1671543839/website%20images/mongodb_sscy2a.svg',
            knowledge: 75
        },
        {
            name: 'PostgreSQL',
            image: 'https://res.cloudinary.com/dyg53cwvw/image/upload/c_scale,w_137/v1671543839/website%20images/PostgreSQL-Logo.wine_i0o7hz.png',
            knowledge: 80
        },
        {
            name: 'AWS S3',
            image: 'https://res.cloudinary.com/dyg53cwvw/image/upload/c_scale,w_137/v1671543838/website%20images/Amazon-S3-Logo.svg_lievhh.png',
            knowledge: 70
        },
        {
            name: 'Stripe',
            image: 'https://res.cloudinary.com/dyg53cwvw/image/upload/c_scale,w_137/v1671543838/website%20images/2919749-middle_griasq.png',
            knowledge: 70
        },
        {
            name: 'Cloudinary',
            image: 'https://res.cloudinary.com/dyg53cwvw/image/upload/c_scale,w_137/v1671543838/website%20images/cloudinary-logo_fbphfw.png',
            knowledge: 75
        }
    ]
}
